import Axios from "axios";
import Store from "@/store";

const axiosConfig = {
  baseURL: `/v1/`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  //timeout: 30000,
};

const axiosClient = Axios.create(axiosConfig);

axiosClient.interceptors.request.use((config) => {
  const token = Store.state.user.userToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    return Promise.reject(error);
  }
);

export { axiosClient };
